import React from 'react';
import styled from 'styled-components';
import showIcon from "../../assets/images/password-show.png";
import hideIcon from "../../assets/images/password-hide.png";
import { mobileChangeWidth } from '../../styles/theme';

interface PasswordToggleButtonProps {
    showPassword: boolean;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    isEvFormText?: boolean;
}

const ToggleButton = styled.button<PasswordToggleButtonProps>`
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    z-index: 2;
    @media only screen and (max-width: ${mobileChangeWidth}) {
        ${props => props.isEvFormText && `
            bottom: 7.5px;
            top: auto;
            transform: translateY(0%);
        `}
    }
`;
const PasswordToggleButton: React.FC<PasswordToggleButtonProps> = ({ showPassword, onClick, isEvFormText }) => {
    return (
        <ToggleButton showPassword={showPassword} onClick={onClick} isEvFormText={isEvFormText ?? false}>
            {showPassword ? (
                <img src={showIcon} alt="show" />
            ) : (
                <img src={hideIcon} alt="hide" />
            )}
        </ToggleButton>
    );
};

export default PasswordToggleButton; 